<app-common-modal
  #addAccessoriesRangeModal
  [name]="'addAccessoriesRangeModal'"
  [title]="' '"
  [twoButtonsDialogs]="true"
  [withFooter]="false">
  <!-- Modal Title -->
  <h4 class="modal-title text-center" modal-title translate>
    T_ACCESSORIES_RANGE_INFORMATION
  </h4>
  <div modal-body>
    <!-- Range Name Heading -->
    <div class="row mb-3">
      <div class="col-12">
        <h5 translate>T_ADD_ACCESSORIES_RANGE_NAME</h5>
      </div>
    </div>
    <!-- Dynamic Language Inputs -->
    <!-- Label -->
    <div *ngFor="let lang of languages" class="accessory-range-name">
      <span class="accessory-range-name-label">{{ lang }}:</span>
      <div class="accessory-range-input-container">
        <input
          [(ngModel)]="rangeNames[lang]"
          class="accessory-range-name-input"
          type="text"
        />
        <span
          *ngIf="containsInvalidAccessoryRangeCharacters(rangeNames[lang])"
          class="combination-disclaimer"
          translate>
          T_ACCESSORIES_RANGE_NAME_INVALID_CHARACTERS
        </span>
      </div>
    </div>

    <!-- Buttons -->
    <div class="modal-add-range-footer mt-4">
      <button
        (click)="cancel()"
        class="btn btn-default-white-background"
        translate>
        T_BUTTON_CANCEL
      </button>

      <button
        (click)="createAccessoryRange(rangeNames); hide()"
        [disabled]="!isValidForm()"
        class="btn btn-default-white-background"
        translate>
        T_ACCESSORIES_RANGE_OK_BUTTON
      </button>
    </div>
  </div>
</app-common-modal>
